import { MemberDashboard } from './../../../models/ss-api/responses/member.dashboard.response';
import { LicenseManager } from '../../../managers/License.manager';
import { MemberEventsService } from '../../../services/member.events.service';
import { Subscription } from 'rxjs';
import { NoteManagerConstructor } from '../../../managers/note.manager';
import { NotesAll } from '../../../models/domain/notes.all';
import { KeyValuePair } from '../../../models/KeyValuePair';
import { ssApiService } from '../../../services/ss-api.service';
import { Note, NoteArray, NoteTypes, NoteChangeResult } from '../../../models/domain/note';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { NoteManager } from '../../../managers/note.manager';
import { BaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { sortDirection } from '../../../models/ss-api/responses/member.dashboard.license.response';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../../app/helpers/sort';
import { NoteDetailsDialog } from '../../../dialogs/note.details/note.details.dialog';
import { DialogService } from '../../../services/modal-dialogs';

class FilterOption {
    label: string;
    value: {
        id: number;
        type: NoteTypes;
    };
}

@Component({
    selector: 'member-notes',
    templateUrl: './member.notes.component.html',
    styleUrls: ['./member.notes.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class MemberNotesComponent implements OnInit, OnDestroy {

    IsBusy: boolean = false;
    @Input('MemberID') MemberID: number;
    @Input('Member') Member: MemberDashboard;

    @Output('updateStickyNotes') updateStickyNotes: EventEmitter<NoteChangeResult> = new EventEmitter();

    Notes: NoteArray = new NoteArray();
    OriginalNotes: NoteArray = new NoteArray();

    MemberNotes: NoteArray = new NoteArray();
    LicenseNotes: NoteArray = new NoteArray();
    CreditNotes: NoteArray = new NoteArray();
    CreditCardNotes: NoteArray = new NoteArray();
    GISNotes: NoteArray = new NoteArray();
    AdminLogNotes: NoteArray = new NoteArray();
    MemberLogNotes: NoteArray = new NoteArray();

    InvoiceNotes: NoteArray = new NoteArray();
    TicketNotes: NoteArray = new NoteArray();
    GISUsageNotes: NoteArray = new NoteArray();

    private subscriptions = new Array<Subscription>();

    // Filter Variables
    memberFilterBool: boolean = true;
    licenseFilterBool: boolean = false;
    creditCardFilterBool: boolean = false;
    creditFilterBool: boolean = false;
    gisFilterBool: boolean = false;
    gisUsageFilterBool: boolean = false;
    invoiceFilterBool: boolean = false;
    ticketFilterBool: boolean = false;
    logFilterBool: boolean = false;
    adminLogFilterBool: boolean = false;
    memberLogFilterBool: boolean = false;
    authenticationLogFilter: boolean = false;
    updateLogFilter: boolean = false;

    AllNotes: boolean = false;

    filterOptions: Array<FilterOption> = new Array<FilterOption>();
    selectedFilters: Array<FilterOption> = new Array<FilterOption>();

    constructor(private api: ssApiService, private memberEvents: MemberEventsService, private windowService: WindowService, private dialogService: DialogService) { }

    ngOnInit() {
        this.filterOptions = [
            {
                label: 'Member',
                value: {
                    id: 0,
                    type: NoteTypes.Member
                }
            },
            {
                label: 'GISCredit',
                value: {
                    id: 1,
                    type: NoteTypes.GISCredit
                }
            },
            {
                label: 'CreditCard',
                value: {
                    id: 2,
                    type: NoteTypes.CreditCard
                }
            },
            {
                label: 'LicenseKey',
                value: {
                    id: 3,
                    type: NoteTypes.LicenseKey
                }
            },
            {
                label: 'Credit',
                value: {
                    id: 4,
                    type: NoteTypes.Credit
                }
            },
            {
                label: 'Invoice',
                value: {
                    id: 5,
                    type: NoteTypes.Invoice
                }
            },
            {
                label: 'Ticket',
                value: {
                    id: 6,
                    type: NoteTypes.Ticket
                }
            },
            {
                label: 'GISUsage',
                value: {
                    id: 7,
                    type: NoteTypes.GISUsage
                }
            },
            {
                label: 'AdminLog',
                value: {
                    id: 8,
                    type: NoteTypes.AdminLog
                }
            },
            {
                label: 'MemberLog',
                value: {
                    id: 9,
                    type: NoteTypes.MemberLog
                }
            },
            {
                label: 'Hubspot',
                value: {
                    id: 10,
                    type: NoteTypes.Hubspot
                }
            }
        ];

        this.SubscribeEvents();
    }

    ngOnDestroy() {
        this.UnsubscribeEvents();
    }

    UnsubscribeEvents() {
        if (this.subscriptions != null)
            this.subscriptions.forEach((s) => { s.unsubscribe(); });

    }

    SubscribeEvents() {
        // memberevents
        let memberEvents = this.memberEvents.onNoteChanged.subscribe((args: EntityChangedArgs<any>) => {
            this.CheckNoteChanged(args);
            return true;
        });
        this.subscriptions.push(memberEvents);
    }

    LicenseClick(key: string): void {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.LoadNotes();
        });
    }

    ToggleAllNotes() {
        this.AllNotes = !this.AllNotes;
        this.LoadNotes();
    }
 

    CheckNoteChanged(args: EntityChangedArgs<any>) {

        switch (Note.GetNoteType(args.New)) {

            case NoteTypes.Member:
                this.UpdateNote(this.MemberNotes, args.New);
                break;

            case NoteTypes.CreditCard:
                this.UpdateNote(this.CreditCardNotes, args.New);
                break;

            case NoteTypes.LicenseKey:
                this.UpdateNote(this.LicenseNotes, args.New);
                break;

            case NoteTypes.GISCredit:
                this.UpdateNote(this.GISNotes, args.New);
                break;

            case NoteTypes.GISUsage:
                this.UpdateNote(this.GISUsageNotes, args.New);
                break;

            case NoteTypes.Credit:
                this.UpdateNote(this.CreditNotes, args.New);
                break;

            case NoteTypes.MemberLog:
                this.UpdateNote(this.MemberLogNotes, args.New);
                break;

            case NoteTypes.AdminLog:
                this.UpdateNote(this.AdminLogNotes, args.New);
                break;

            case NoteTypes.Ticket:
                this.UpdateNote(this.TicketNotes, args.New);
                break;

            case NoteTypes.Invoice:
                this.UpdateNote(this.InvoiceNotes, args.New);
                break;

        }

    }

    UpdateNote(notes: NoteArray, newNote: Note): void {
        if (notes === undefined || notes == null) {
            return;
        }

        let index = notes.findIndex(x => x.ID == newNote.ID);
        if (index > -1) {
            notes[index] = newNote;
        }

        this.sortNotesByCreateDate(notes);
    }

    NoteTest() {

    }

    LoadNotes(memberID: number = 0) {

        this.IsBusy = true;

        if (memberID == 0)
            memberID = this.MemberID;

        this.Notes.length = 0;
        if (this.AllNotes){
            let disposable = this.api.getAllNotesForFamily(memberID).subscribe(

                (result: BaseResponse<NotesAll>) => {
                    disposable.unsubscribe();
                    this.AssignAndSortNotes(result.Data);
                    this.IsBusy = false;
                },
    
                (error: any) => {
                    disposable.unsubscribe();
                    this.IsBusy = false;
                }
    
            );
        }
        else{
            let disposable = this.api.getAllNotesForMember(memberID).subscribe(

                (result: BaseResponse<NotesAll>) => {
                    disposable.unsubscribe();
                    this.AssignAndSortNotes(result.Data);
                    this.IsBusy = false;
                },
    
                (error: any) => {
                    disposable.unsubscribe();
                    this.IsBusy = false;
                }
    
            );
    
        }

    }

    AssignAndSortNotes(myNotes: NotesAll) {

        if (myNotes.MemberNotes && myNotes.MemberNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, ...myNotes.MemberNotes];
        }

        if (myNotes.LicenseNotes && myNotes.LicenseNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, ...myNotes.LicenseNotes];
        }

        if (myNotes.CreditCardNotes && myNotes.CreditCardNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, ...myNotes.CreditCardNotes];
        }

        if (myNotes.CreditNotes && myNotes.CreditNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, ...myNotes.CreditNotes];
        }

        if (myNotes.GISNotes && myNotes.GISNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, ...myNotes.GISNotes];
        }

        if (myNotes.GISUsageNotes && myNotes.GISUsageNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, myNotes.GISUsageNotes];
        }

        if (myNotes.AdminLogNotes && myNotes.AdminLogNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, myNotes.AdminLogNotes];
        }

        if (myNotes.MemberLogNotes && myNotes.MemberLogNotes.length > 0) {
            this.Notes = <NoteArray>[...this.Notes, myNotes.MemberLogNotes];
        }

        if (this.Notes.length > 0) {
            this.OriginalNotes = <NoteArray>[...this.Notes];
            this.Notes = SortBot.SortAsc(this.Notes, 'Created');
        }

    }

    onFilterChange(event) {
        this.selectedFilters = event;
        if (this.selectedFilters.length == 0) {
            this.Notes = this.OriginalNotes;
        } else {
            this.Notes = <NoteArray>this.OriginalNotes.filter((note) => {
                if (note.NoteTypeList) {
                    for (let type of note.NoteTypeList) {
                        for (let filter of event) {
                            if (filter.type == type.Key) {
                                return true;
                            }
                        }
                    }
                }
            });
        }
    }

    EditNote(note: Note) {
        // let noteManager = new NoteManager(new NoteManagerConstructor(note.ID));
        let noteData = new NoteManagerConstructor();
        noteData.NoteID = note.ID;
        noteData.HasReviewed = this.Member.HasReviewed;
        this.ShowNoteDialog(noteData);
    }

    AddMemberNote() {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.Member, this.MemberID);

        let noteData = new NoteManagerConstructor();
        noteData.MemberID = this.MemberID;
        noteData.HasReviewed = this.Member.HasReviewed;
        noteData.NoteType = type;
        noteData.RelationObject = this.Member;
        noteData.IsAddNote = true;
        console.log("aa", noteData);
        this.ShowNoteDialog(noteData);

    }


    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options = {
            width: 1240,
            height: 650
        };
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        });
    }

    DeleteNote(note: Note, noteType: NoteTypes) {

        switch (noteType) {
            case NoteTypes.AdminLog:
                this.FindAndDeleteNote(note, this.AdminLogNotes);
                break;
            case NoteTypes.MemberLog:
                this.FindAndDeleteNote(note, this.MemberLogNotes);
                break;
            case NoteTypes.Credit:
                this.FindAndDeleteNote(note, this.CreditNotes);
                break;
            case NoteTypes.CreditCard:
                this.FindAndDeleteNote(note, this.CreditCardNotes);
                break;
            case NoteTypes.GISCredit:
                this.FindAndDeleteNote(note, this.GISNotes);
                break;
            case NoteTypes.GISUsage:
                this.FindAndDeleteNote(note, this.GISUsageNotes);
                break;
            case NoteTypes.LicenseKey:
                this.FindAndDeleteNote(note, this.LicenseNotes);
                break;
            case NoteTypes.Member:
                this.FindAndDeleteNote(note, this.MemberNotes);
                break;
        }

    }

    FindAndDeleteNote(note: Note, noteArray: NoteArray) {
        for (let n of noteArray) {
            if (n.ID == note.ID) {
                noteArray.splice(noteArray.indexOf(n), 1);
                break;
            }
        }
    }

    sortNotesByCreateDate(noteToSort: NoteArray, noteSortDirection: sortDirection = sortDirection.Descending) {
        if (noteToSort == undefined)
            return;

        this.IsBusy = true;
        noteToSort = SortBot.SortAsc(noteToSort, 'Created');
        this.IsBusy = false;
    }


    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    Toggle() {
        this.memberFilterBool = false;
        this.licenseFilterBool = false;
        this.creditCardFilterBool = false;
        this.creditFilterBool = false;
        this.gisFilterBool = false;
        this.gisUsageFilterBool = false;
        this.invoiceFilterBool = false;
        this.ticketFilterBool = false;
        this.logFilterBool = false;
        this.adminLogFilterBool = false;
        this.memberLogFilterBool = false;
        this.authenticationLogFilter = false;
        this.updateLogFilter = false;
    }

    NotesChanged(note: NoteChangeResult) {
        this.updateStickyNotes.emit(note);
    }

}
